export default __webpack_public_path__ + "static/media/foot-right-inside.68f35717.png";